import { DATE_FORMATS } from "../constants";

import dayjs from "dayjs";

export const isDate = (text: string): boolean =>
  !!text &&
  typeof text === "string" &&
  (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(text) ||
    /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{1,}){0,1}([Z]|(\+[0-9]{2}:[0-9]{2})){0,1}$/.test(
      text
    )) &&
  dayjs(text).isValid();

export const isDateOnly = (text: string): boolean =>
  !!text &&
  typeof text === "string" &&
  /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(text) &&
  dayjs(text, DATE_FORMATS.YearMonthDayIso).isValid();

export const isTimeOnly = (text: string): boolean =>
  !!text &&
  typeof text === "string" &&
  /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(text) &&
  dayjs(text, DATE_FORMATS.HourMinuteSecond24Hour).isValid();